module.exports = __webpack_public_path__ + "img/page1.56ead1f4.jpg";